import { IPoint } from 'framework/utils/math-utils';
import { IHexGridData } from 'js/bubbleCore/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';
import { Hex } from 'js/bubbleCore/Hex';
import { gridOffsetToSpaceOffset } from 'js/bubbleCore/utils/gridOffsetToSpaceOffset';

const tempHexes = Hex.getTempHexes();

export function gridHexToSpacePosition<T>(col: number, row: number, grid: IHexGridData<T>): IPoint {
  const hex = tempHexes[grid.type].setOffset(col, row);
  const point = hex.getPosition();
  const offset = gridOffsetToSpaceOffset(grid);
  point.x += offset.x;
  point.y += offset.y;
  return point;
}